import globalParams from "@/CommonDP/utils/globalParams";
import { registerStdFlowForm } from "@/CommonDP/components/processComponents/config/flowFormRegister.js";

import JumpComponent from "@/CommonDP/pages/mainMg/application/jumpComponent.vue";
const emptyComponent = { render: () => undefined }; // 默认空组件
export default {
  initGlobalParams(customParams) {
    globalParams.set("demoKey", "demoValue");
    // 任务详情：是否关键到流程
    globalParams.set("task.detail.bindToFlow", false);
    // 组织架构：是否允许维护机构
    globalParams.set("org.readonly", false);
    // 组织架构：是否允许维护机构人员
    globalParams.set("org.user.readonly", false);
    // 企业用户管理：是否让界面变成只读
    globalParams.set("enterprise.user.readonly", false);
    // 菜单类型 默认第一种 '1' || '2'
    globalParams.set("leftMenuType", "1");
    // 左侧侧边栏显隐：是否隐藏
    globalParams.set("hideMainSide", false);
    // 顶头右边消息显隐：是否隐藏
    globalParams.set("hideMessageBtn", false);
    // 顶头右边插件下载显隐：是否隐藏
    globalParams.set("hideDownloadBtn", false);
    // 顶头右边帮助手册显隐：是否隐藏
    globalParams.set("hideHelpBtn", false);
    // 系统文件夹非最底级是否可存放文件
    globalParams.set("doc.canUploadToReadOnlyFolder", false);

    // 密码的加密的 RSA key
    globalParams.set(
      "login.pwd.encRsaPublicKey",
      "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvGrkKaYRkpkhkVG7kUg" +
        "7vfbmOMlGp9KB/rFe" +
        "Fva+DYDGL2PLkEur0IJEj73SK5Okuiy/sQ0paopfYoCfc3hL01lLYNvUKnpaN3OUz1YKgzGTnpsrGqrihMjknq7tefMwcmneK0lgRA" +
        "Ii7x05J25Vp88UBLt4BGdS+W/UwX+YW+ker4U51sEUqL8TbjNtLdwA1y1m9W1OD3/dPZh0WReuTiJFiYz064gYUpXTxDFiX6I6R1m6" +
        "jM8Ug3p5lVaWv2uRG7nXAhy3VH7pSoWmq6jZi/lb1MYbIqq82eQrEd6rDxh1Lbb036NGkofgNpK4QoigvK569Hp2/EWNXFJ4arnzmwIDAQAB"
    );
    // 通过 RSA 加密后的密码前缀，用于兼容不加密的模式。对加密的密码特别区分
    globalParams.set("login.pwd.encryptedPwdPrefix", "_XXX_");

    // 文档批注：自定义按钮
    globalParams.set("doc.annotation.headButtons", emptyComponent);
    globalParams.set("doc.annotation.tailButtons", emptyComponent);
    // office 文件获取预览地址的自定义方法（需要返回 Promise）
    globalParams.set("doc.office.getPreviewFn", emptyComponent);

    // 文档管理：自定义操作按钮
    globalParams.set("doc.operation.buttons", emptyComponent);

    // 文档权限管理：自定义权限分类，输入必需为数组。
    // 请参考：documentPermission/index.vue 中 ALL_PERMISSION_TYPES 所指定的全部分组
    // 举例：[1, 3]
    globalParams.set("doc.permission.types", []);

    /**
     * 自定义图标 例：{'admin': "add.png",'work': "del.png"}
     * 图标必须放在CommonDP/assets/definedIcon下,只需要有名称和后缀即可
     * 替换逻辑在src/CommonDP/utils/tree.js 体现
     */
    globalParams.set("definedIcon", {});

    // 是否忽略关键目录设置 详见src/CommonDP/router/method/method.js下的beforeEachproject方法实现
    globalParams.set("isIgnoreDirPlan", false);
    // 是否是航空院
    // 项目-成员 列表里阶段子项字段 是否隐藏
    globalParams.set("project.person.hideSubitem", true);
    // 自定义选人组件
    globalParams.set("custom.chooseMember", null);

    // 全局路由守卫,默认返回一个成功态的promise,执行默认的路由守卫
    globalParams.set("beforeEach", function (to, from, next) {
      return Promise.resolve(to, from, next);
    });

    // 全局路由守卫,默认返回一个成功态的promise,执行默认的路由守卫
    globalParams.set("afterEach", function (to, from, next) {
      return Promise.resolve(to, from, next);
    });
    globalParams.set("prjPlan.disableUserPlan", 0);
    // 注册公共流程的表单
    registerStdFlowForm();

    globalParams.set("application-largeScreenStatistic.6494200285888513", JumpComponent);

    // 控制在线设计打印显示与否
    globalParams.set("onlinePrintDesign", false);
    // 允许扩展或重写参数
    if (!customParams || !customParams.length) {
      return;
    }
    customParams.forEach((param) => {
      globalParams.set(param.name, param.value);
    });
  }
};
